export default __webpack_public_path__ + "static/media/1BHK B (WS) 3D.ddfc5b51.png";